import { moveItemsToSectionOptimistically } from '../utils/quote-helpers';
import { useQuoteMutation } from './create-quote-mutation';

interface MoveItemsVariables {
  itemIds: string[];
  targetSectionId: string | null;
}

/**
 * Move multiple items to a section with optimistic updates
 * Items move immediately in UI before API confirmation
 */
export const useMoveItems = (quoteId: string) =>
  useQuoteMutation<MoveItemsVariables>({
    quoteId,
    optimisticUpdate: (quote, { itemIds, targetSectionId }) =>
      moveItemsToSectionOptimistically(quote, itemIds, targetSectionId)
  });
